import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Modal,
  Typography,
  Box,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import axios from "../../../axiosInstance";
import Sidebar_admin from "../Sidebar_Admin/Sidebar_admin";
import "./AdsManagement.css"

const AdsManagement = () => {
  const [ads, setAds] = useState([
    { id: 1, placement: "Header", page: "Home" },
    { id: 2, placement: "Footer", page: "Home" },
    { id: 3, placement: "Middle", page: "Home" },
    { id: 4, placement: "Header", page: "News" },
    { id: 5, placement: "Footer", page: "News" },
    { id: 6, placement: "Middle", page: "News" },
  ]);

  const [modalOpen, setModalOpen] = useState(false);
  const [editAd, setEditAd] = useState(null);
  const { register, handleSubmit, reset } = useForm();

  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [tableVisible, setTableVisible] = useState(false);

  const states = ["Default","TamilNadu", "Pondicherry"];
  const districtsByState = {
    Default:['Default'],
    TamilNadu: ['Ariyalur', 'Chengalpattu', 'Chennai', 'Coimbatore', 'Cuddalore', 'Dharmapuri',
      'Dindigul', 'Erode', 'Kallakurichi', 'Kancheepuram', 'Kanniyakumari', 'Karur', 'Krishnagiri',
      'Madurai', 'Mayiladuthurai', 'Nagapattinam', 'Namakkal', 'Nilgiris', 'Perambalur', 'Pudukkottai',
      'Ramanathapuram', 'Ranipet', 'Salem', 'Sivaganga', 'Tenkasi', 'Thanjavur', 'Theni',
      'Thoothukudi', 'Tiruchirappalli', 'Tirunelveli', 'Tirupattur', 'Tiruppur', 'Tiruvallur',
      'Tiruvannamalai', 'Tiruvarur', 'Vellore', 'Viluppuram', 'Virudhunagar'
    ],
    Pondicherry: ["Pondicherry", "Karaikal", "Mahe", "Yanam"],
  };

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    setSelectedDistrict(""); // Reset district
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
    setTableVisible(true); // Show table only after selecting district
  };

  const openModal = (ad) => {
    setEditAd(ad);
    reset({ image: null });
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const onSubmit = async (data) => {
    if (!editAd || !selectedState || !selectedDistrict) return;

    const formData = new FormData();
    formData.append("state", selectedState);
    formData.append("district", selectedDistrict);
    formData.append("placement", editAd.placement);
    formData.append("page", editAd.page);
    if (data.image[0]) formData.append("image", data.image[0]);

    try {
      await axios.post("/api/admin/ads", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      closeModal();
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
    }
  };

  return (
    <div>
      <Sidebar_admin />
      <Box className="ads-management-container">
        <Typography variant="h4" gutterBottom>
          Ads Management
        </Typography>

        {/* State and District Selection */}
        <FormControl fullWidth sx={{ pr: 1 }} margin="normal">
          <InputLabel>State</InputLabel>
          <Select value={selectedState} onChange={handleStateChange}>
            {states.map((state) => (
              <MenuItem key={state} value={state}>
                {state}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedState && (
          <FormControl fullWidth margin="normal">
            <InputLabel>District</InputLabel>
            <Select value={selectedDistrict} onChange={handleDistrictChange}>
              {districtsByState[selectedState]?.map((district) => (
                <MenuItem key={district} value={district}>
                  {district}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {/* Table - Visible Only After District is Selected */}
        {tableVisible && (
          <TableContainer component={Paper} className="table-container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Ad ID</TableCell>
                  <TableCell>Placement</TableCell>
                  <TableCell>Page</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ads.map((ad) => (
                  <TableRow key={ad.id}>
                    <TableCell>{ad.id}</TableCell>
                    <TableCell>{ad.placement}</TableCell>
                    <TableCell>{ad.page}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => openModal(ad)} color="primary">
                        <CloudUpload />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Modal for Uploading Image */}
        <Modal open={modalOpen} onClose={closeModal}>
          <Box className="modal-container">
            <Typography variant="h6" gutterBottom>
              Upload Ad Image
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <TextField type="file" sx={{ width: "100px" }} margin="normal" {...register("image")} />

              <Typography variant="body1" margin="normal">
                <strong>State:</strong> {selectedState} | <strong>District:</strong> {selectedDistrict}
              </Typography>
              <Typography variant="body1" margin="normal">
                <strong>Placement:</strong> {editAd?.placement} | <strong>Page:</strong> {editAd?.page}
              </Typography>

              <Box className="modal-buttons">
                <Button onClick={closeModal} color="secondary">
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  Upload
                </Button>
              </Box>
            </form>
          </Box>
        </Modal>
      </Box>
    </div>
  );
};

export default AdsManagement;
